var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.$t('blank'),"directory":_vm.$t('sample_pages'),"icon":'copy'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }